import { z } from 'zod';

export const InternalNetworkTunnelSessionRequestSchema = z.object({
  internalAccessNetworkId: z.string().min(1).optional(),
});

export const InternalNetworkTunnelHostAliasSchema = z.object({
  hostname: z.string().min(1),
  ip: z.string().min(1),
});

export const InternalNetworkTunnelSessionSchema = z.object({
  sessionId: z.string().min(1),
  sessionToken: z.string().min(1),
  expiresAt: z.string().datetime(),
  tenantId: z.string().min(1),
  internalAccessNetworkId: z.string().min(1),
  networkSlug: z.string().min(1),
  wsPath: z.string().min(1),
  advertisedRoutes: z.array(z.string().min(1)).min(1),
  hostAliases: z.array(InternalNetworkTunnelHostAliasSchema),
  splitDnsDomains: z.array(z.string().min(1)).optional(),
});

export const InternalNetworkTunnelRevokeRequestSchema = z.object({
  sessionId: z.string().min(1),
});

export const InternalNetworkTunnelRevokeResponseSchema = z.object({
  revoked: z.boolean(),
});

export const InternalNetworkTunnelErrorResponseSchema = z.object({
  message: z.string(),
});

export const InternalNetworkTunnelOpenPayloadSchema = z.object({
  host: z.string().min(1),
  port: z.number().int().min(1).max(65535),
});

export const InternalNetworkTunnelErrorPayloadSchema = z.object({
  message: z.string().min(1),
});

export type InternalNetworkTunnelSessionRequest = z.infer<
  typeof InternalNetworkTunnelSessionRequestSchema
>;
export type InternalNetworkTunnelSession = z.infer<
  typeof InternalNetworkTunnelSessionSchema
>;
export type InternalNetworkTunnelRevokeRequest = z.infer<
  typeof InternalNetworkTunnelRevokeRequestSchema
>;
export type InternalNetworkTunnelOpenPayload = z.infer<
  typeof InternalNetworkTunnelOpenPayloadSchema
>;
